import React, { useEffect, useState } from 'react';
import { Container, Spacer, Text, Flex, Img, Link as Link2, HStack, VStack, Button } from '@chakra-ui/react';
import { Connect } from '../components/Connect';
import { Navigation } from './Navigation';
import RR from '../assets/crohamcity.webp';
import Twitter from '../assets/twitter.webp';
import EB from '../assets/eb.png';
import TG from '../assets/tg.png';
import CDC from '../assets/CDC.png';
import Medium from '../assets/medium.png';
import Discord from '../assets/discord.png';
import PUUSH from '../assets/PUUSH.png';
import DS from '../assets/dex.png';
import { useMoralis } from 'react-moralis';
import { Link } from 'react-router-dom';

const Header = () => {
  const { account } = useMoralis();
  const [address, setAddress] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [buttBalance, setButtBalance] = useState(0);

  useEffect(() => {
    setAddress(String(account));
  }, [account]);

  useEffect(() => {
    if (address && address.includes("0x")) {
      const API_KEY_CRONOSCAN = "V0B7jKfZaBhjDjmexQSkzRPWTcNv16bF";
      const getTokenBalance = async (Address:string) => {
        try {
// New base (mainnet): https://explorer-api.cronos.org/mainnet/api/v2
const apiUrl = `https://explorer-api.cronos.org/mainnet/api/v2?module=account&action=tokenbalance&contractaddress=0x2dfA528939D38a3654ad44a4748BE591e283a32f&address=${Address}${API_KEY_CRONOSCAN ? `&apikey=${API_KEY_CRONOSCAN}` : ''}`;
          const response = await fetch(apiUrl);
          const data = await response.json();
          if (data.status === "1") {
            setButtBalance(Number(data.result));
            setLoaded(true); // Set loaded to true once fetching is complete
          } else {
            console.error("Failed to fetch token balance");
          }
        } catch (error) {
          console.error("Error fetching token balance:", error.message);
        }
      };

      getTokenBalance(address);
    }
  }, [address]);

  return (
    <Container maxW="full" centerContent>
      <Flex wrap="nowrap" alignItems={'center'} direction="column" gap="1" justifyContent="center">
        <Flex wrap="nowrap" alignItems="center" direction="row" gap="7" justifyContent="center">
          <Text
            padding="2vw"
            style={{ textShadow: '1px 1px 20px black' }}
            paddingTop="2vmax"
            fontSize="3vmax"
            fontWeight="500"
            color="white"
          >
            {'WELCOME TO CROHAM CITY'}
          </Text>
        </Flex>

        <Flex wrap="nowrap" alignItems="center" direction="row" gap="1" justifyContent="center" transform="scale(1.7)">
          <Link2
            padding="0.3vw"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            borderRadius="50%"
            style={{ textAlign: 'center', color: 'orangered', margin: '0.5vmax' }}
            href="https://www.x.com/buttmanoncro"
            _hover={{ transform: 'scale(1.2)', backgroundColor: 'rgba(255, 69, 0, 0.8)' }}
          >
            <img style={{ borderRadius: '50%', width: '2vmax' }} src={Twitter} alt="Twitter" />
          </Link2>

          <Link2
            padding="0.3vw"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            borderRadius="50%"
            style={{ textAlign: 'center', color: 'orangered', margin: '0.5vmax' }}
            href="https://t.me/ButtmanOnCro"
            _hover={{ transform: 'scale(1.2)', backgroundColor: 'rgba(255, 69, 0, 0.8)' }}
          >
            <img style={{ borderRadius: '50%', width: '2vmax' }} src={TG} alt="Telegram" />
          </Link2>

          <Link2
            padding="0.3vw"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            borderRadius="50%"
            style={{ textAlign: 'center', color: 'orangered', margin: '0.5vmax' }}
            href="https://PUUSH.fun/"
            _hover={{ transform: 'scale(1.2)', backgroundColor: 'rgba(255, 69, 0, 0.8)' }}
          >
            <img style={{ borderRadius: '50%', width: '2vmax' }} src={PUUSH} alt="PUUSH.FUN" />
          </Link2>

          <Link2
            padding="0.3vw"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            borderRadius="50%"
            style={{ textAlign: 'center', color: 'orangered', margin: '0.5vmax' }}
            href="https://crypto.com/"
            _hover={{ transform: 'scale(1.2)', backgroundColor: 'rgba(255, 69, 0, 0.8)' }}
          >
            <img style={{ borderRadius: '50%', width: '2vmax' }} src={CDC} alt="Crypto.com" />
          </Link2>

          <Link2
            padding="0.3vw"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            borderRadius="50%"
            style={{ textAlign: 'center', color: 'orangered', margin: '0.5vmax' }}
            href="https://dexscreener.com/cronos/0x2dfA528939D38a3654ad44a4748BE591e283a32f/"
            _hover={{ transform: 'scale(1.2)', backgroundColor: 'rgba(255, 69, 0, 0.8)' }}
          >
            <img style={{ borderRadius: '50%', width: '2vmax' }} src={DS} alt="DS" />
          </Link2>

          <Connect />
   
        </Flex>

        <Flex wrap="nowrap" alignItems="center" direction="row" justifyContent="space-around">
        <VStack
            paddingInline="1vmax"
            width="fit-content"
            rowGap="0.0"
            alignItems="left"
            fontSize="1vmax"
            color="white"
         
          >
            <HStack  bg="rgba(0,0,0,0.6)" backdropFilter="blur(10px)" borderRadius="xl" boxShadow="lg"  textAlign={"center"}    gap={"0.1vmax"}>
              <Text  dropShadow={'10px 10px 10px white'} fontSize={"1.5vmax" } color="yellow"> $BUTT: </Text>
              {loaded ? (
                <Text fontSize={"1.5vmax" } textAlign={"center"} >{buttBalance > 0 ? (buttBalance / 1e18).toFixed(0) : '0'}</Text>
              ) : (
                <Text textAlign={"center"} >$$$</Text>
              )}
            </HStack>
            <Navigation />
          </VStack>
        
        </Flex>
        <Spacer />
      </Flex>
    </Container>
  );
};

export default Header;
